// Sarnia Builder plans. One catalogue read by both the server (checkout, requests) and the web app (pricing, billing).
// The marketing copy below is a first draft: edit the strings here and every page updates.
export const FREE_PLAN = {
    id: 'free',
    name: 'Free',
    tagline: 'Everything you need to build a site and take it with you. Free, always.',
    features: [
        'No card, no time limit, no catch',
        'Build with any template or start from scratch',
        'Shareable live preview link (marked as a preview)',
        'Export your finished website as a ZIP to host anywhere',
        'Visual editor with images, colours, fonts and effects'
    ]
};
export const PLANS = [
    {
        id: 'basic-monthly',
        name: 'Basic',
        priceMinor: 1499,
        currency: 'GBP',
        interval: 'month',
        tagline: 'We do the setup and the maintenance for you.',
        features: [
            'Everything in Free',
            'Hands-on help setting your site live on your own domain',
            'Ongoing website maintenance',
            'Email support'
        ]
    },
    {
        id: 'premium-monthly',
        name: 'Premium',
        priceMinor: 2999,
        currency: 'GBP',
        interval: 'month',
        tagline: 'The same help, with priority and more hands-on care.',
        features: [
            'Everything in Basic',
            'Priority setup and priority support',
            'More hands-on maintenance and content updates',
            'Help with domains, email and growing your site'
        ],
        highlight: true
    }
];
export const PLAN_IDS = PLANS.map((p) => p.id);
export function getPlanInfo(id) {
    return PLANS.find((p) => p.id === id) ?? null;
}
/** 1499 -> "£14.99" */
export function formatPlanPrice(plan) {
    return `£${(plan.priceMinor / 100).toFixed(2)}`;
}
//# sourceMappingURL=plans.js.map